import React from "react";
import currencyFormatter, { Currency } from "../../../js/common/CurrencyFormatter";
import { CheckoutOrderViewAccessory } from "./checkoutOrderView";

interface BasketListAccessoryProperties {
    readonly orderAccessory: CheckoutOrderViewAccessory;
    readonly currency: Currency;
}

export default function BasketListAccessory({ orderAccessory, currency }: BasketListAccessoryProperties): React.JSX.Element {
    return (
        <div className="cart-item-wrap accessory">
            <div className="cart-item-inner">
                <div className="cart-item-product-image">
                    <span className="cart-item-product-image-helper"></span>
                    <img src={orderAccessory.imageUrl} alt="" />
                </div>
                <div className="cart-item-product-title-availability-labels">
                    <span className="cart-accessory-title">{orderAccessory.title}</span>
                    {orderAccessory.description !== null && <span dangerouslySetInnerHTML={{ __html: orderAccessory.description }}></span>}
                </div>
                <div className="cart-item-product-price">
                    <span className="price-now">{currencyFormatter.formatCurrencyWithSymbol(orderAccessory.price, currency)}</span>
                </div>
            </div>
        </div>
    );
}
